import IntegrationsFileImport from "../component/integrationsfileimport/IntegrationsFileImport";
import { SOURCE_CONSTANTS } from "../constants";
import NetSuiteInstruction from "./NetSuiteInstruction";

export default function NetSuite() {

    return (
        <>
            <IntegrationsFileImport source={SOURCE_CONSTANTS.NETSUITE_SOURCE} >
                <NetSuiteInstruction />
            </IntegrationsFileImport>
        </>
    );
}